import { getUserId } from '../../../../../helpers';
import { compact, uniq, isEmpty } from 'lodash'

export const getMembersToSave = ({ folder, membersToAdd, membersToRemove }) => {
    if (membersToAdd === null) return null;
    const userId = getUserId()
    const members = compact(uniq([userId, folder?.createdBy, ...(membersToAdd || [])])).filter(id => !membersToRemove?.includes(id))
    return !isEmpty(members) ? members : [userId]
}